import { apiRequest } from "./api";

function buildQuery(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    search.set(key, String(value));
  });
  return search.toString();
}

export function listToolCategories(params = {}) {
  const query = buildQuery(params);
  return apiRequest(query ? `/api/v1/tool-categories?${query}` : "/api/v1/tool-categories");
}

export function listToolApps(params = {}) {
  const query = buildQuery(params);
  return apiRequest(query ? `/api/v1/tool-apps?${query}` : "/api/v1/tool-apps");
}

export function listToolAppModelConfigs(appCode) {
  return apiRequest(`/api/v1/tool-apps/${encodeURIComponent(appCode)}/model-configs`);
}
